import React from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import uniq from 'lodash/uniq'

import Loading from 'discada/dist/Loading'

import {
  getRebateById,
  getMinRebateValue,
  getMaxRebateValue,
  getCompatCategoriesForRebate,
} from 'selectors/quoteSelectors'

import { getRebateDetails } from 'selectors/appStatusSelectors'
import { getRebateFinePrint } from 'actions/quoteActions'

import { money } from 'utils'

import './RebateDetails.scss'

export class RebateDetails extends React.Component {
  componentDidMount() {
    let { rebateId, getRebateFinePrint } = this.props

    getRebateFinePrint([rebateId])
  }

  render() {
    let { rebate = {}, details, minValue, maxValue, compats } = this.props,
      {
        Name,
        NameDisplay,
        StopDate,
        MinCreditScore,
        MaxCreditScore,
        RevisionDate,
        TransactionType,
      } = rebate,
      vals = uniq([minValue, maxValue].filter(v => v))
        .map(v => money(v))
        .join(' - ')

    return isEmpty(rebate) || isEmpty(details) ? (
      <Loading size="small" />
    ) : (
      <div className="rebate-details">
        <div className="rebate-details-header">
          <h3>{Name || NameDisplay}</h3>
          {rebate.Number}
          {vals && (
            <>
              <br />
              {vals}
            </>
          )}
          <br />
        </div>
        <p className="rebate-details-body">{details}</p>
        <div className="rebate-details-footer">
          For {TransactionType === 'any' ? 'all' : TransactionType} programs
          {!isEmpty(compats) ? (
            <>, compatilble with {compats.join(', ')}.</>
          ) : (
            ''
          )}{' '}
          {StopDate &&
            ` Available through ${moment(StopDate).format(
              'LL',
            )}, Last revised ${moment(RevisionDate).format('LL')}.`}{' '}
          Credit score of {MinCreditScore}&mdash;{MaxCreditScore} required. May
          not apply to all programs. Application of any cash value may vary
          based on program. Ask your dealer to verfiy your eligibility.
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let { vehicleId, quoteId, rebateId } = op,
    rebate = getRebateById(state, vehicleId, quoteId, op.rebateId, {}) || {},
    details = getRebateDetails(state, rebateId)

  return {
    ...op,
    rebate,
    details,
    minValue: getMinRebateValue(rebate),
    maxValue: getMaxRebateValue(rebate),
    compats: getCompatCategoriesForRebate(state, vehicleId, quoteId, rebate.ID),
  }
}

export default connect(
  mapStateToProps,
  { getRebateFinePrint },
)(RebateDetails)
